// Host-published content ("活动详情") card entry helper.
// See docs/prd-activity-detail-onsite.md section 2.2.

interface HostMessageBooking {
  status: string;
  hostMessage?: { available: boolean };
  session: { endTime: string; isCancelled: boolean };
}

// The entry stays on the card until 7 days after the session ends. The details
// page itself is not window-gated; only this discoverable entry is.
const HOST_MESSAGE_VISIBLE_MS = 7 * 24 * 60 * 60 * 1000;

/** Card entry visibility per PRD 2.2. */
export function showHostMessageButton(booking: HostMessageBooking, now = Date.now()): boolean {
  return (
    booking.status.toUpperCase() === 'CONFIRMED' &&
    !booking.session.isCancelled &&
    Boolean(booking.hostMessage?.available) &&
    now < new Date(booking.session.endTime).getTime() + HOST_MESSAGE_VISIBLE_MS
  );
}

interface MeasurableFrame {
  style: { height: string };
  contentDocument: { documentElement: { scrollHeight: number } } | null;
}

/**
 * Measure the srcDoc iframe's content height for auto-sizing.
 * scrollHeight never reports less than the current frame height, so the frame
 * must be collapsed first or the page keeps blank space after the fluid email
 * card reflows shorter (e.g. rotating to landscape). Returns null when the
 * document is not accessible yet.
 */
export function measureFrameContentHeight(frame: MeasurableFrame): number | null {
  const doc = frame.contentDocument;
  if (!doc) return null;
  frame.style.height = '0px';
  const height = doc.documentElement.scrollHeight;
  frame.style.height = `${height}px`;
  return height;
}
